import React from 'react';
import PropTypes from 'prop-types';
import getContent from 'pp-react-l10n';
import getHTMLElement from '../lib/setHtmlHelper';

const MostPopularArticles = ({ country, articleInfo, popArticlesHomeInfo }) => {
  const getPopContent = getContent('staticContent');
  const category = articleInfo.breadCrumbs[0];

  return (
    <aside className="rightPopArticleContainer">
      <div className="popularArticlesContainer">
        <div className="parentdiv">
          <h2 className="vx_text-2 popularHeading">
            {getPopContent('brc.mostPopArticles')}
          </h2>
          <div>
            <a
              data-pa-click={`brcPopularArticle|${category.id}`}
              tabIndex="-1"
              aria-label="button as arrow"
              className="popCategoryRightArrow"
              href={`/${country}/brc/topics/${category.id}`}
            />
          </div>
          <h3 className="list-link popCategoryHeading">
            <a
              data-pa-click={`brcPopularArticle|${category.id}`}
              className="list-link popCategoryHeading"
              href={`/${country}/brc/topics/${category.id}`}
            >
              {category.title}
            </a>
          </h3>
          <ul className="section-container">
            {popArticlesHomeInfo &&
              popArticlesHomeInfo.map((tile, index) => {
                const listItemId = `popular-list-item-${index}`;
                return (
                  <li id={listItemId} className="" key={index}>
                    <hr className="borderLine" />
                    <a
                      data-pa-click={'popularArticle|' + tile.url_slug}
                      className="reqPath"
                      href={`/${country}/brc/article/${tile.url_slug}`}
                      key={tile.url_slug + index}
                    >
                      <div className="articleLink" key={tile.heading + index}>
                        {getHTMLElement(tile.heading, { useHTML: true })}{' '}
                      </div>
                    </a>
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    </aside>
  );
};

MostPopularArticles.propTypes = {
  country: PropTypes.string,
  popArticlesHomeInfo: PropTypes.array,
  articleInfo: PropTypes.object,
};

export default MostPopularArticles;
